export default {
  props: ["value", "label", "disabled", "tooltip"],
};
